// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import { MultiSelect } from '@loa/ui-components';
import type { QuoteProvider } from '../../types/quote';

export type ProviderMultiSelectProps = Readonly<{
  label: string;
  options: QuoteProvider[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
}>;

/**
 * Provider picker for the quote-request forms — a thin adapter over the shared
 * {@link MultiSelect} (full keyboard model: Arrow keys, Space/Enter toggle,
 * Tab-target, type-ahead). Maps providers to value/text options.
 */
export function ProviderMultiSelect({
  label,
  options,
  selectedIds,
  onChange,
}: ProviderMultiSelectProps) {
  return (
    <MultiSelect
      label={label}
      required
      fluid
      placeholder="Select providers"
      options={options.map((o) => ({ value: o.id, text: o.name }))}
      selectedValues={selectedIds}
      onChange={onChange}
      data-testid="provider-multi-select"
    />
  );
}
